// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

const utility = require.context('.', true, /\.js$/)
utility.keys().forEach(utility)
